import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=69d86896&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=69d86896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d86896",
  null
  
)

export default component.exports